import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {LoginService} from '../login.service';
import * as CryptoJS from 'crypto-js';
import { DatePipe } from '@angular/common';
import { sha256, sha224 } from 'js-sha256';
import { ServerConstantsService } from '../serverConstants.service';

@Component({
  selector: 'app-household',
  templateUrl: './household.component.html',
  styleUrls: ['./household.component.css']
})
export class HouseholdComponent implements OnInit {
  private gridApi;
  private gridColumnApi;
  defaultColDef = { resizable: true, cellStyle:{'font-size':'14px'} };
  columnDefs = [
    {headerName: 'Name', field: 'name' },
    {headerName: 'Relationship', field: 'relationship' },
    {headerName: 'Gender', field: 'gender'},
    {headerName: 'Date of Birth', field: 'dob'},
    {headerName: 'Work Participation Status', field: 'wpc'},
    {headerName: 'Other Characterstics', field: 'other'}
];

rowData = [];

constructor(public loginService:LoginService, public toastService:ToastrService,
  private datePipe: DatePipe){}

  ngOnInit() {
    this.getUserInfo(this.loginService.personId);
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    //this.gridApi.setDomLayout("autoHeight");
  }
  getUserInfo(id){
    this.loginService.getuser(id).subscribe((data)=>{
      if(data["id"]){
        let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
        CryptoJS.AES.decrypt(sessionStorage.getItem('conversion_stat'), key).toString(CryptoJS.enc.Utf8) === 'true' ?  
        this.getAriescitizenInfo(data["emciId"]) :this.getcitizenInfo(data["ssn"]);
      }
      else{
        this.toastService.error("Unable to load User Information","My Dashboard");
      }
    },error=>{
      this.toastService.error("Unable to load User Information","My Dashboard");
    })
  }
  getcitizenInfo(ssn){
    let request = {
      "ssn":ssn
    }
    this.loginService.getClientinfo(request).subscribe((data:Array<Object>)=>{
      if(data[0]["CLIENTID"]){
        data.forEach((element)=>{
          let record = {
            name:null,
            relationship:null,
            gender:null,
            dob:null,
            wpc:null,
            other:null,
          }
          record.name = element["HH_MEMB_NAME"];
          record.relationship = element["HH_MEM_RELATIONSHIP"];
          if(element["HH_MEM_GENDER"] == 'M'){
            record.gender= 'Male';
          }
          else{
            record.gender = 'Female';
          }
          let dobDt = element["HH_MEM_DOB"].split(' ')[0];
          if(dobDt != null) { 
            record.dob= this.datePipe.transform(dobDt, 'MM/dd/yyyy');
          }
          //record.dob = element["HH_MEM_DOB"].split(' ')[0];
          record.wpc = element["HH_MEM_WP"];
          record.other = element["HH_MEM_OTH_CHAR"];
          if(record.relationship == 'Self'){
            if(this.rowData.find(obj => obj.relationship == 'Self') == undefined){
              this.rowData.push(record);
            }
          }
          else{
            this.rowData.push(record);
          }          
        })
        this.gridApi.setRowData(this.rowData);
      }
      else{
        this.toastService.error("Unable to load Household Information","My Information");
      }
    },error=>{
      this.toastService.error("Unable to load Household Information","My Information");
    })
  }

  getAriescitizenInfo(value){
    let request = {
      "type":"householdInfo",
      "value":value
    }
    this.loginService.getClietinfoAries(request).subscribe((data)=>{
      if(data["indvId"]){
        data["relation"].forEach((element)=>{
          let record = {
            name:null,
            relationship:null,
            gender:null,
            dob:null,
            wpc:null,
            other:null,
          }
          record.name = element["indvName"];
          record.relationship = element["relationshipTypeCd"];
          if(element["genderCd"] == 'M'){
            record.gender= 'Male';
          }
          else{
            record.gender = 'Female';
          }
          let dobDt = new Date(element["dobDt"]);
          if(dobDt != null) { 
            record.dob= this.datePipe.transform(dobDt, 'MM/dd/yyyy');
          }
          //record.dob = element["HH_MEM_DOB"].split(' ')[0];
          record.wpc = element["wrkParticipationCd"];
          record.other = null;
          if(record.relationship == 'Self'){
            if(this.rowData.find(obj => obj.relationship == 'Self') == undefined){
              this.rowData.push(record);
            }
          }
          else{
            this.rowData.push(record);
          }          
        })
        this.gridApi.setRowData(this.rowData);
      }
      else{
        this.toastService.error("Unable to load Household Information","My Information");
      }
    },error=>{
      this.toastService.error("Unable to load Household Information","My Information");
    })
  }
  focus(event){
    if(event.keyCode == 9){
      event.preventDefault();
      this.gridApi.ensureIndexVisible(0);
      let firstCol = this.gridColumnApi.getAllDisplayedColumns()[0];
      this.gridApi.ensureColumnVisible(firstCol);
      this.gridApi.setFocusedCell(0, firstCol);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/household/household.component.ts